import { Box, ProgressBar, Table, Tag, Text } from '@factorialco/deprecated-design-system'

import { dateBackendToUI } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { tagColor, tagLabel } from 'modules/surveys/lib/tagConstants'
import type Survey from 'modules/surveys/store/models/v2/Survey'

import Settings from './Settings'

interface ParticipationProps {
  form: Survey
}

function Participation({ form }: ParticipationProps) {
  if (form.isDraft) return <>-</>

  return (
    <ProgressBar
      showLabel
      amount={form.attributes.answered_questions_count}
      total={form.attributes.question_groups_count}
    />
  )
}

interface Props {
  forms: Survey[]
}

export default function TableBody({ forms }: Props) {
  const noFormDescription = i18n.t('surveys.index.table.body.no_surveys')

  return (
    <Table.Body>
      {!forms.length && (
        <Table.Row>
          <Table.Cell colSpan={11}>
            <Box alignItems="center" justifyContent="center" padding="s24">
              <Text.Normal>{noFormDescription}</Text.Normal>
            </Box>
          </Table.Cell>
        </Table.Row>
      )}
      {!!forms.length &&
        forms.map((form) => {
          const { id, status, name, start_on, end_on } = form.attributes
          const labelType = tagColor(status)
          const genericLabel = tagLabel(status)

          return (
            <Table.Row key={id}>
              <Table.Cell colSpan={2}>
                <Text.Normal weight="medium">{name}</Text.Normal>
              </Table.Cell>
              <Table.Cell colSpan={2}>
                <Participation form={form} />
              </Table.Cell>
              <Table.Cell colSpan={2}>
                <div
                  style={{
                    display: 'inline-flex',
                  }}
                >
                  <Tag leftItem="circle" capitalize showCircle type={labelType}>
                    {genericLabel}
                  </Tag>
                </div>
              </Table.Cell>
              <Table.Cell colSpan={2}>
                <Text.Normal>{start_on ? dateBackendToUI(start_on) : '-'}</Text.Normal>
              </Table.Cell>
              <Table.Cell colSpan={2}>
                <Text.Normal>{end_on ? dateBackendToUI(end_on) : '-'}</Text.Normal>
              </Table.Cell>
              <Table.Cell colSpan={1}>
                <Settings survey={form} />
              </Table.Cell>
            </Table.Row>
          )
        })}
    </Table.Body>
  )
}
